import type { ReactElement } from 'react';
import React from 'react';
import sortBy from 'lodash/sortBy';
import { useEthnicities } from 'services/assist-api/entities/ethnicity/ethnicities';

export default function EthnicityDisplay({
  ethnicityIds
}: {
  ethnicityIds: number[];
}): ReactElement {
  const ethnicities = useEthnicities().data?.json;
  const ethnicityNames = sortBy(
    ethnicities?.filter((eth) => ethnicityIds.includes(eth.id)).map((eth) => eth.name)
  );
  return <>{ethnicityNames.join(', ')}</>;
}
